<template>
  <!-- 门诊专区管理 -->
  <div class="outpatientZone">
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-link
          style="margin-right: 5px"
          icon="el-icon-question"
          type="primary"
          :href="baseUrl + '/UploadFile/Template/专区商品批量导入.xls'"
          target="_blank"
          >下载模板</el-link
        >
        <el-button type="success" style="margin-right: 5px" @click="exdata"
          >导入商品列表</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="delDell"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >添加</el-button
        >
      </template>
    </page-header>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">专区管理：</label>
        <el-select
          placeholder="专区管理"
          style="width: 100px; margin-right: 5px"
          @change="outpaZone"
          disabled
          v-model="searchForm.prefecture"
        >
          <el-option
            v-for="(item, index) in typeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="article_id"
        show-overflow-tooltip
        label="商品id"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="goodscode"
        show-overflow-tooltip
        label="商品编号"
      >
      </el-table-column>
      <el-table-column
        prop="sub_title"
        label="商品名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort_id"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="drug_spec"
        label="商品规格"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="建议零售价"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="stock_quantity"
        label="库存"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="approval_number"
        label="国药准字"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="drug_factory"
        label="生产厂家"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="添加时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 新增专区商品 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">专区信息</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="formRule"
            ref="addForm"
          >
            <!-- <el-form-item label="所属专区" prop="type">
              <el-select
                style="width: 100%; margin-right: 5px"
                v-model="addForm.type"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="商品">
              <!-- <el-input
                @click.native="getGoodsList(1)"
                v-model="addForm.name"
                placeholder="请选择商品"
                clearable
              ></el-input> -->
              <div
                class="selectGoods"
                v-for="(item, index) in selectedGoods"
                :key="item.goodscode"
              >
                <div class="selectGoods-title">{{ item.sub_title }}</div>
                <el-button type="text" @click="handleDeleteGoods(index)"
                  >删除</el-button
                >
              </div>
              <el-button type="primary" @click="getGoodsList(1)"
                >选择</el-button
              >
            </el-form-item>
            <!-- <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="addForm.sort"
                style="width: 100%"
                :min="1"
                placeholder="请输入排列序号"
              ></el-input-number>
            </el-form-item> -->
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <!-- 绑定商品dialog -->
    <el-dialog
      title="商品列表"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchForm2.name"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getGoodsList(1)"
            >搜索</el-button
          >
          <el-button type="warning" @click="submitForm">确定添加</el-button>
        </template>
      </search-bar>
      <el-table
        height="300px"
        :data="goodData"
        stripe
        border
        @selection-change="selectionName"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="keyid"
          show-overflow-tooltip
          label="商品编号"
        >
        </el-table-column>
        <el-table-column
          prop="sub_title"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="drug_spec"
          label="商品规格"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="price_ck"
          label="建议零售价"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="stock_quantity"
          label="库存"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="drug_factory"
          label="生产厂家"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="big_package"
          label="件装量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-plus"
              @click="handleJoin(scope)"
              >加入</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanCurrChange="hanCurrChange2"
        layout="total, prev, pager, next, jumper"
      ></pagination>
    </el-dialog>
    <upload
      ref="upload"
      style="dispay: none"
      @fileChange="uploadGoods"
      :multiple="true"
    ></upload>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "outpatientZone",
  data() {
    return {
      entId: "",
      userId: "",

      /**表格数据 */
      //商品编号	商品名称	排序	商品规格	建议零售价	库存	国药准字	生产厂家	添加时间
      tableData: [],
      goodData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [] /**存放选中的数据 */,
      /**搜索表单 */
      addForm: {
        type: "",
        name: "",
        sort: "",
      },
      searchForm: {
        name: "",
        prefecture: "1",
      },
      typeList: [
        // { value: '0', label: '近效期专区' },
        // { value: '1', label: '中药专区' },
        // { value: '2', label: '保健专区' },
      ],
      dialogVisible: false,
      row: "",
      //商品编号	名称	规格	中包装	件装量	生产厂家	库存
      goodsList: [
        {
          number: "商品编号",
          name: "名称",
          specification: "规格",
          mediumPackage: "中包装",
          packages: "生产厂家",
          producer: "生产厂家",
          repertory: "库存",
        },
      ] /**商品列表 */,
      /**分页数据 */
      currPage2: 1,
      pageSize2: 10,
      allPage2: 0,
      addDrawer: false,
      /**搜索表单 */
      searchForm2: {
        name: "",
      },
      formRule: {
        type: [mustFill],
        // name: [mustFill],
        // sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      selectedGoods: [], //选中商品
      id: "",
    };
  },
  mounted() {
    this.getTypeList();
    if (this.$route.query.prams !== undefined) {
      let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
      if (prams.id) {
        this.searchForm.prefecture = prams.id;
        this.entId = window.localStorage.getItem("entId");
        this.userId = window.localStorage.getItem("userId");
        this.getTableData(1);
      }
    }
  },
  methods: {
    exdata() {
      this.$refs.upload.handleClick();
    },
    // 商品详情图片上传回调
    uploadGoods(file) {
      file = file.slice(0, 200); //最多可选择200张，多余的将会截断
      if (file.length) {
        let fileData = new FormData();
        for (let i = 0; i < file.length; i++) {
          fileData.append("FileNmaes", file[i]);
        }
        this.$uploadRequest({
          url:
            "Management/GoodsAdmin/ToExcelImportGoodsSaleArrondi?arrondiType=" +
            this.searchForm.prefecture,
          method: "post",
          data: fileData,
        })
          .then((res) => {
            console.log(res);
            if (res.flag == 0) {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              this.$confirm(res.message + "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {});
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      }
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    updata() {
      this.getTypeList();
    },
    // 获取专区列表
    getTypeList() {
      let data = {
        entId: this.entId,
        navType: "ExpertList",
        status: "2",
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            console.log(res);
            this.typeList = (res.list || []).map((item) => ({
              label: item.title,
              value: item.Id,
            }));
          } else {
            this.typeList = [];
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Pc_GetArrondiProduct",
        strWhere: this.searchForm.name,
        ArrondiType: this.searchForm.prefecture, //this.searchForm.prefecture
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Brand"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "brand/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    outpaZone() {
      this.getTableData();
    },
    selectionName(selection) {
      this.selectedGoods = selection;
    },
    // 确定添加
    sureModify() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          var json = {
            type: "Pc_SetArrondiProduct",
            article_id: this.row.keyid,
            sort_id: this.addForm.sort,
            ArrondiType: this.addForm.type,
          };
          var proc = "Proc_Admin_Brand"; // 存储过程名
          var type = "ReturnNumber";
          ///加载页面数据
          this.$request({
            method: "post",
            url:
              "brand/ashx/returnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(json)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.addDrawer = false;
                this.getTableData();
                this.$message({
                  message: res.message,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },

    /**获取商品数据 */
    getGoodsList(index) {
      this.currPage2 = index;
      let data = {
        type: "GoodsList",
        strWhere: this.searchForm2.name,
        pageIndex: this.currPage2,
        pageSize: this.pageSize2,
        spid: "",
      };
      let proc = "Proc_Admin_SearchInfo"; // 存储过程名
      let type = "ReturnDataSet";
      this.$request({
        method: "post",
        data,
        url:
          "admin/ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          encodeURIComponent(type) +
          "&proc=" +
          encodeURIComponent(proc),
        dataType: "json",
      })
        .then((res) => {
          this.goodData = [];
          if (res.flag == 0) {
            this.goodData = res.content;
            this.allPage2 = res.recordCount;
            this.dialogVisible = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    rowClick(row) {
      this.row = row;
      this.addForm.name = row.sub_title;
      this.dialogVisible = false;
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList(val);
    },

    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },

    /**点击添加商品 */
    handleAdd() {
      // this.addDrawer = true;
      this.getGoodsList();
      this.dialogVisible = true;
    },

    /**取消绑定 */
    clearForm() {
      this.addForm.type = "";
      this.selectedGoods = [];
      this.addDrawer = false;
    },

    // 批量删除
    delDell() {
      let idList = [];
      this.selectedList.forEach((i) => {
        idList.push(i.article_id);
      });
      idList = idList.join();
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            type: "PC_DelArronPro",
            strWhere: idList,
            ArrondiType: this.searchForm.prefecture, //this.searchForm.prefecture
          };
          let proc = "Proc_Admin_Brand"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "coupon/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },

    /**将选中商品加入待提交商品列表 */
    handleJoin({ row }) {
      //过滤已经选中的商品
      for (let i = 0; i < this.selectedGoods.length; i++) {
        let item = this.selectedGoods[i];
        if (item.keyid == row.keyid) {
          this.$message({
            message: "该商品已添加",
            type: "warning",
          });
          return;
        }
      }
      this.$message({
        message: "添加成功",
        type: "success",
      });
      this.selectedGoods.push(row);
    },

    /**删除选中的商品 */
    handleDeleteGoods(index) {
      this.selectedGoods.splice(index, 1);
    },

    /**提交商品 */
    submitForm() {
      // this.$refs.addForm.validate((valid) => {
      //   if (valid) {
      let goodsId = this.selectedGoods.map((item) => {
        return item.keyid;
      });

      this.$request({
        method: "post",
        url: "Goods/SaveGoodsSaleArrondi",
        data: {
          entId: this.entId,
          articleStr: goodsId.join(),
          arrondiType: this.searchForm.prefecture,
        },
      })
        .then((res) => {
          let type = res.success ? "success" : "error";
          this.$message({
            message: type,
            type: type,
          });
          this.dialogVisible = false;
          if (res.success) {
            this.getTableData(1);
            this.clearForm();
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
      //   }
      // });
    },
  },
};
</script>

<style scoped>
.outpatientZone {
  width: 100%;
  height: 100%;
}

/**选中商品 */
.selectGoods {
  display: flex;
  justify-content: space-between;
}

.selectGoods-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
